export default __webpack_public_path__ + "static/media/nav-right.4e46ab04.svg";